import { Controller } from "@hotwired/stimulus"
import { Popover } from "bootstrap"

export default class extends Controller {
  static values = { text: String }
  connect() {
    this.popover = new Popover(this.element, {
      content: this.textValue, title: "", trigger: "hover focus",
      placement: "auto", container: "body", boundary: "viewport"
    })
  }
  disconnect() { this.popover?.dispose() }
}
